import moment from 'moment'
import * as constants from '../mixins/constants'
import { getFCMSubscriptionToken, getItemStorage, removeItemStorage, setItemStorage } from './util'
import { updatePush } from '@/store/api/user'

const { find } = require('@/plugins/lodash')

const state = {
  sentMessageToSW: function (message) {
    return new Promise(function (resolve, reject) {
      var messageChannel = new MessageChannel()

      messageChannel.port1.onmessage = function (event) {
        if (event.data.error) {
          reject(event.data.error)
        } else {
          resolve(event.data)
        }
      }

      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(message, [messageChannel.port2])
      }
    })
  },
  onChangOrderStatus(data, store, $root, router) {
    let status
    switch (data.type) {
      case 'order_rebroadcast':
        status = constants.ORDER_STATUS.ASSIGNING
        break
      case 'order_accept':
        status = constants.ORDER_STATUS.ACCEPTED
        break
      case 'order_pickup':
        status = constants.ORDER_STATUS.IN_PROCESS
        break
      case 'order_board': // TODO: support legacy to 17 Jan 2019
        status = constants.ORDER_STATUS.IN_PROCESS
        break
      case 'order_complete':
        status = constants.ORDER_STATUS.COMPLETED
        break
      case 'order_cancel':
        status = constants.ORDER_STATUS.CANCELLED
        break
      case 'order_fail':
        status = constants.ORDER_STATUS.FAILED
        break
      case 'balance_update':
        $root.$emit('balanceUpdate', data)
        break
    }
    if (status) {
      const orderId = data.order_id
      // console.log('status: ', status, data)
      if (orderId && store.getters.orderId) {
        const path = orderId.split('-')[1]
        if (path) {
          store.dispatch('setActivePath', {
            id: parseInt(path.trim()),
            status: status
          })
        } else {
          store.dispatch('setOrderStatus', status)
        }
      } else {
        if (router.app.$route.name === 'records') {
          // console.log("emit orderUpdateStatus event to records page");
          $root.$emit('orderUpdateStatus', {
            _id: data.order_id,
            status: status
          })
        } else {
          store.dispatch('resetOrders')
        }
      }
      $root.$emit('updateOrderTimeline', {
        _id: data.order_id,
        status: status
      })
    }
  },
  showMessage(data, store) {
    const msg = (({ _id, title, message, image_url, url, url_require_token }) => ({
      _id,
      title,
      message,
      image_url,
      url,
      url_require_token
    }))(data)
    msg.format_time = moment().fromNow()
    msg.read = true
    store.dispatch('setActiveMessage', msg)
    store.dispatch('putMessage', msg)
  },
  messageListener: function (router, store, $root) {
    if (navigator.serviceWorker) {
      // console.log('messageListener', router, store, $root)
      navigator.serviceWorker.addEventListener('message', (event) => {
        const data = event.data
        // console.log("messageListenerxxxxx: ", event);
        if (data) {
          switch (data.type) {
            case 'get_data':
              break
            case 'news':
              this.showMessage(data, store)
              break
            case 'promotion':
              break
            case 'confirm_binding_account':
              store.dispatch('getUserProfile')
              store.dispatch('setStatusBindZaloPay', true)
              break
            default:
              this.onChangOrderStatus(data, store, $root, router)
          }
        }
      })
    }
  },
  askPermission: function () {
    return new Promise(function (resolve, reject) {
      const permissionResult = Notification.requestPermission(function (result) {
        resolve(result)
      })

      if (permissionResult) {
        permissionResult.then(resolve, reject)
      }
    }).then(function (permissionResult) {
      if (permissionResult !== 'granted') {
        throw new Error("We weren't granted permission.")
      }
    })
  },
  updateSubcriptionToServer(store, cookie) {
    const token = (store && store.getters.token) || (cookie && cookie.get('token'))
    const subscription = getFCMSubscriptionToken()
    // console.log('OFFLINE-HANDLER: updateSubcriptionToServer token', token)
    // console.log('OFFLINE-HANDLER: updateSubcriptionToServer subscription', subscription)
    if (token && subscription) {
      const userProfileStr = getItemStorage(constants.LOCAL_STORAGE_KEY__USER)
      if (userProfileStr) {
        const profile = JSON.parse(userProfileStr)
        const device = find(profile.devices, (d) => {
          return d.type === process.env.VUE_APP_PLATFORM && d.app === process.env.VUE_APP_NAME
        })

        if (device && device.push === subscription) {
          return
        }
      }

      // const updatePushAPI = process.env.VUE_APP_API_URL.concat(
      //   constants.API.user.update_push
      // );
      const params = {
        push: subscription,
        imei: store.getters.loginParams.imei,
        fcm: store.getters.loginParams.fcm
      }

      updatePush(params)
        .then(() => {})
        .catch((e) => {
          this.onUpdatePushError(e)
        })
    }
  },
  onUpdatePushError(e) {
    const res = e.response
    if (res && res.status === 404 && res.data && res.data.title === 'Token not found') {
      this.$cookie.delete(constants.COOKIE_NAME__TOKEN)
      this.$cookie.delete(constants.COOKIE_NAME__TOKEN, {
        domain: this.$_VUE_APP_DOMAIN
        // process.env.VUE_APP_DOMAIN
      })
      removeItemStorage(constants.LOCAL_STORAGE_KEY__USER)
      // console.log("onUpdatePushError: Remove token");
    }
  },

  async initFirestore() {
    const [firebaseModule] = await Promise.all([
      import(/* webpackMode: "lazy" */ 'firebase/app').catch((err) => {
        console.log('OFFLINE-HANDLER: cannot import firebase', err)
      }),
      import(/* webpackMode: "lazy" */ 'firebase/firestore').catch((err) => {
        console.log('OFFLINE-HANDLER: cannot import firebase/firestore', err)
      })
    ])

    const firebase = (firebaseModule && firebaseModule.default) || firebaseModule

    var ahaChatApp

    if (!(firebase.apps && firebase.apps.length)) {
      const config = {
        apiKey: process.env.VUE_APP_FIRESTORE_API_KEY,
        authDomain: process.env.VUE_APP_FIRESTORE_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_FIRESTORE_DB_URL,
        projectId: process.env.VUE_APP_FIRESTORE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_FIRESTORE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_FIRESTORE_MESSAGING_SENDER_ID,
        appId: process.env.VUE_APP_FIRESTORE_APP_ID
      }
      console.log('config ahachat', config)
      ahaChatApp = firebase.initializeApp(config)
    } else {
      ahaChatApp = firebase.app()
      // console.log("aha chat app else ", ahaChatApp);
      console.log('OFFLINE-HANDLER: Already ahaChatApp app', ahaChatApp)
    }
  },

  async initFirebaseMessaging(store, cookie) {
    // Load firebase/app and firebase/messaging in parallel (Firebase 8 API)
    const [firebaseModule] = await Promise.all([
      import(/* webpackMode: "lazy" */ 'firebase/app').catch((err) => {
        console.log('OFFLINE-HANDLER: cannot import firebase', err)
      }),
      import(/* webpackMode: "lazy" */ 'firebase/messaging').catch((err) => {
        console.log('OFFLINE-HANDLER: cannot import firebase/messaging', err)
      })
    ])

    const firebase = (firebaseModule && firebaseModule.default) || firebaseModule

    var firebaseApp

    if (!firebase.apps.length) {
      const config = {
        apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
        projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.VUE_APP_FIREBASE_AUTH_APP_ID
      }
      console.log('cofig offline-handle 2', config)
      firebaseApp = firebase.initializeApp(config)
    } else {
      firebaseApp = firebase.app()
      console.log('OFFLINE-HANDLER: Already firebases app', firebaseApp)
    }

    const messaging = firebaseApp.messaging()

    // Register service worker, save registration for getToken()
    let serviceWorkerRegistration
    await new Promise((resolve, reject) => {
      if ('serviceWorker' in navigator) {
        try {
          navigator.serviceWorker.register('/firebase-messaging-sw.js').then((registration) => {
            serviceWorkerRegistration = registration
            resolve()
          })
        } catch (error) {
          reject(error)
        }
      } else {
        reject()
      }
    }).catch(() => {
      store.dispatch('setServiceWorkerSupport', false)
    })

    const vapidKey = process.env.VUE_APP_FIREBASE_WEB_PUSH_CERTIFICATES_KEY

    Notification.requestPermission()
      .then((permission) => {
        if (permission !== 'granted') {
          store.dispatch('setNotificationsBlocked', true)
          return
        }
        console.log('OFFLINE-HANDLER: requestPermission')

        messaging
          .getToken({ vapidKey, serviceWorkerRegistration })
          .then((fcmToken) => {
            console.log('fcmToken', fcmToken)
            store.dispatch('setNotificationsBlocked', false)
            console.log('OFFLINE-HANDLER: fcmToken', fcmToken)

            if (!window.app) {
              window.app = {}
            }
            window.app.subscription = fcmToken
            setItemStorage(constants.LOCAL_STORAGE_KEY__FCM_TOKEN, fcmToken)
            this.updateSubcriptionToServer(store, cookie)
          })
          .catch((err) => {
            console.log('OFFLINE-HANDLER: getToken err', err)
            if (err && err.code && err.code.indexOf('messaging') > -1) {
              store.dispatch('setNotificationsBlocked', true)
            }
          })
      })
      .catch((err) => {
        if (err && err.code && err.code.indexOf('messaging') > -1) {
          store.dispatch('setNotificationsBlocked', true)
        }
      })

    if (typeof messaging.onTokenRefresh === 'function') {
      messaging.onTokenRefresh(() => {
        messaging
          .getToken({ vapidKey, serviceWorkerRegistration })
          .then((refreshedToken) => {
            console.log('refreshedToken', refreshedToken)
            if (!window.app) {
              window.app = {}
            }
            window.app.subscription = refreshedToken
            setItemStorage(constants.LOCAL_STORAGE_KEY__FCM_TOKEN, refreshedToken)
            this.updateSubcriptionToServer(store, cookie)
          })
          .catch((err) => {
            if (err && err.code && err.code.indexOf('messaging') > -1) {
              store.dispatch('setNotificationsBlocked', true)
            }
          })
      })
    }
  }
}

export default async ({ $router, $store, $root, $cookie }) => {
  // await state.initFirebaseMessaging($store, $cookie);
  // await state.initFirestore();
  state.messageListener($router, $store, $root)
  state.updateSubcriptionToServer($store, $cookie)
}
